import React, { useState } from 'react';
import {
  TextField, IconButton, InputAdornment, Typography,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

type PasswordFieldProps = {
  password: string,
  setPassword: (password: string) => void,
  id: string,
  disabled?: boolean,
}

function PasswordField(props: PasswordFieldProps) {
  const {
    password, setPassword, id, disabled,
  } = props;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <Typography variant="caption" component="div" color="secondary" gutterBottom>{id}</Typography>
      <TextField
        onChange={(e) => setPassword(e.target.value)}
        id={id}
        size="small"
        value={password}
        fullWidth
        disabled={disabled}
        variant="outlined"
        type={showPassword ? 'text' : 'password'}
        autoComplete="off"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                id="showPassword"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="toggle password visibility"
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
          inputProps: { 'data-testid': 'data-pw' },
        }}
      />
    </>
  );
}

PasswordField.defaultProps = {
  disabled: false,
};

export default PasswordField;
